module.exports = __webpack_public_path__ + "img/network-analytics-tab-overview.2dc08e5a.png";